import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

const ORDER = ["Draft", "Processing", "Published/Deployed", "Paused/Unpublished"];
const COLORS = { Draft: "k-muted", Processing: "k-tag-info", "Published/Deployed": "k-tag-green", "Paused/Unpublished": "k-tag-warn" };

export default function MyBuilds({ orgId }) {
  const [data, setData] = useState(null);
  const nav = useNavigate();
  const load = useCallback(async () => {
    if (!orgId) return;
    try { const { data } = await api.get(`/orgs/${orgId}/my-builds`); setData(data); } catch {}
  }, [orgId]);
  useEffect(() => { load(); }, [load]);

  if (!data) return null;
  return (
    <div data-testid="my-builds" style={{ marginTop: 24 }}>
      <h2 className="k-heading" style={{ fontSize: 20, marginBottom: 4 }}>My builds</h2>
      <p className="k-muted" style={{ fontSize: 12, marginTop: 0 }}>{data.note}</p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(240px,1fr))", gap: 14 }}>
        {ORDER.map(col => (
          <div key={col} className="k-container" data-testid={`bucket-${col.replace(/\W/g, "-")}`} style={{ padding: 14 }}>
            <div className={COLORS[col]} style={{ fontSize: 12, fontWeight: 700, marginBottom: 10 }}>● {col} ({data.buckets[col].length})</div>
            {data.buckets[col].length === 0 ? <div className="k-muted" style={{ fontSize: 12 }}>—</div> :
              data.buckets[col].map(p => (
                <div key={p.id} className="k-control" data-testid={`mybuild-${p.id}`} style={{ marginBottom: 6, cursor: "pointer" }}
                  onClick={() => nav(`/workspace/project/${p.id}`)}>
                  <div className="k-heading" style={{ fontSize: 13, fontWeight: 600 }}>{p.name}</div>
                  {p.live_deployment_url && <div className="k-muted" style={{ fontSize: 11 }}>{p.live_deployment_url}</div>}
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
}
